import styled from "styled-components";
import {
  useCreateClaimContext,
  useCreateClaimDispatch,
} from "../CreateClaimContext";
import { useTranslation } from "react-i18next";
import { ButtonCancel, ButtonConfirm } from "../../../../../../Layout/Buttons";
import { BasePolicy } from "../../../../../../../redux/apiSpecifications/apiClaims";
import moment from "moment";
import PolicyDataForm from "./PolicyDataForm";
import InsuredPropertyDataForm from "./InsuredPropertyDataForm";

const PolicyInfoStepWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2em;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  gap: 1em;
  align-items: center;
  justify-content: flex-end;
`;

const validateForm = (model: BasePolicy) => {
  const insuredProperty = model.insuredProperty;

  const isInsuredPropertyValid =
    insuredProperty &&
    insuredProperty.plateNumber &&
    insuredProperty.chassisNumber &&
    insuredProperty.type &&
    insuredProperty.brand &&
    insuredProperty.model;

  return (
    model.tenantId &&
    model.effectDate &&
    model.expirationDate &&
    model.insuredProperty &&
    isInsuredPropertyValid
  );
};

interface IPolicyInfoStepProps {
  onNextStep: () => void;
  onPreviousStep: () => void;
}

const PolicyInfoStep = ({
  onNextStep,
  onPreviousStep,
}: IPolicyInfoStepProps) => {
  const { t } = useTranslation();

  const { createClaimData } = useCreateClaimContext();

  const dispatch = useCreateClaimDispatch();

  const handleOnChange = (value: any, field: string) => {
    dispatch!({
      type: "CHANGE_CLAIM_DATA",
      payload: {
        value: value,
        field: `selectedPolicy.${field}`,
      },
    });
  };

  const model = createClaimData?.selectedPolicy!;

  const effectDate = model?.effectDate
    ? moment(model.effectDate, "DD/MM/YYYY")
    : null;

  const expirationDate = model?.expirationDate
    ? moment(model.expirationDate, "DD/MM/YYYY")
    : null;

  const disableForm = model.id !== undefined;

  const enableNextButton = disableForm || validateForm(model);

  return (
    <PolicyInfoStepWrapper>
      <PolicyDataForm
        model={model}
        disableForm={disableForm}
        onChange={handleOnChange}
      />

      <InsuredPropertyDataForm
        model={model.insuredProperty!}
        disableForm={disableForm}
        onChange={(value, field) =>
          handleOnChange(value, `insuredProperty.${field}`)
        }
      />

      <ButtonsWrapper>
        <ButtonCancel onClick={onPreviousStep}>
          {t("BUTTONS.previous")!}
        </ButtonCancel>

        <ButtonConfirm onClick={onNextStep} disabled={!enableNextButton}>
          {t("BUTTONS.next")!}
        </ButtonConfirm>
      </ButtonsWrapper>

      {/* <pre>{JSON.stringify(createClaimData?.selectedPolicy, null, 2)}</pre> */}
    </PolicyInfoStepWrapper>
  );
};

export default PolicyInfoStep;
